<template>
    <nav class="top wsl-flex-center-ng wsl-w-100">
        <div class="container wsl-flex-middle-ng">
            <img class="wsl-hide-xs" height="38" src="../assets/img/logo.png"/>
            <img class="wsl-show-xs" height="38"
                 src="../assets/img/logo-short.png"/>

            <div class="t18 wsl-m-l-auto wsl-hide-xs">
                <span class="cb-blue Oswald-DemiBold">8 800 </span>
                <span class="cb-cyan Oswald-DemiBold">700 01 86</span>
            </div>
            <div class="wsl-hide-xs wsl-h-100">
                <ul class="wsl-flex-middle-ng wsl-h-100 wsl-p-l-30">
                    <li><a href="//centerbooking.org/registration" target="_blank">Регистрация</a></li>
                    <router-link to="/contacts" tag="li">Контакты</router-link>
                    <li><a href="//centerbooking.org/login" target="_blank">Вход</a></li>
                </ul>
            </div>
            <div class="wsl-show-xs wsl-h-100 wsl-m-l-auto">
                <ul class="wsl-flex-middle-ng wsl-h-100 wsl-p-l-30">
                    <li><a href="//centerbooking.org/registration" target="_blank">Регистрация</a></li>
                    <router-link to="/contacts" tag="li">Контакты</router-link>
                    <li><a href="//centerbooking.org/login" target="_blank">Вход</a></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'Nav'
}
</script>

<style scoped>

</style>
